
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class TaskInstanceDialog extends SiteEntityDialog<TaskInstanceRow, any> {
        protected getFormKey() { return TaskInstanceForm.formKey; }
        protected getIdProperty() { return TaskInstanceRow.idProperty; }
        protected getLocalTextPrefix() { return TaskInstanceRow.localTextPrefix; }
        protected getNameProperty() { return TaskInstanceRow.nameProperty; }
        protected getService() { return TaskInstanceService.baseUrl; }

        protected form = new TaskInstanceForm(this.idPrefix);

        protected updateInterface() {
            super.updateInterface();

            this.cloneButton.hide();
            this.toolbar.findButton('edit-button').hide();
            this.toolbar.element.hide();
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var task = TaskRow.getLookup().itemById[(this.entity || {}).TaskId];

            this.propertyGrid.enumerateItems((item, editor) => {
                if (WorkflowInstanceNamedFields[item.name]) {
                    if (task && task[item.name + "Name"]) {
                        editor.getGridField().show()
                            .find('label.caption').text(titleize(task[item.name + "Name"]));
                    }
                    else if (task) {
                        editor.getGridField().hide();
                    }
                }
            });

            Workflow.replaceWithJsonViewer(this.form.Properties.element, this.entity.Properties);

            this.form.Documents.taskInstanceId = this.entityId;
        }
    }
}